export default function StudyHallGallery() {
  const images = [
    { id: 1, url: "/images/Studyhall/about2.jpeg"},
    { id: 2, url: "/images/Studyhall/about1.jpeg" },
    { id: 3, url: "/images/Studyhall/gallery/1.jpeg"},
    { id: 4, url: "/images/Studyhall/gallery/3.jpeg"},
    { id: 5, url: "/images/Studyhall/gallery/4.jpeg"},
    { id: 6, url: "/images/Studyhall/gallery/6.jpeg"},
    { id: 7, url: "/images/Studyhall/gallery/7.jpeg"},
    { id: 8, url: "/images/Studyhall/gallery/8.jpeg"},
    { id: 9, url: "/images/Studyhall/gallery/9.jpeg"},
    { id: 10, url: "/images/Studyhall/gallery/10.jpeg"},
    { id: 11, url: "/images/Studyhall/gallery/11.jpeg"},
    { id: 12, url: "/images/Studyhall/gallery/12.jpeg"},
    { id: 13, url: "/images/Studyhall/gallery/13.jpeg"},
    { id: 14, url: "/images/Studyhall/gallery/14.jpeg"},
    { id: 15, url: "/images/Studyhall/gallery/15.jpeg"},
    { id: 16, url: "/images/Studyhall/gallery/16.jpeg"},
  ];

  return (
    <section className="py-10 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="max-w-[85rem] mx-auto px-4">
        <div className="mb-12 text-center">
          <h1 className="mb-3 text-4xl font-bold text-gray-900">Study Hall Gallery</h1>
          <p className="text-lg text-gray-600">Explore our collection of inspiring study spaces</p>
        </div>

        <div className="gap-4 space-y-4 columns-1 sm:columns-2 lg:columns-3 xl:columns-4">
          {images.map((image) => (
            <div key={image.id}
              className="relative overflow-hidden transition-all duration-300 bg-white shadow-md cursor-pointer break-inside-avoid group rounded-xl hover:shadow-2xl">
              <div className="relative overflow-hidden">
                <img src={image.url} alt={image.title} className="object-cover w-full h-auto transition-transform duration-500 transform group-hover:scale-110" loading="lazy"/>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}